import { useEffect, useState } from "react";
import { getPersonalInfo } from "../../../actions/dashboardAction";
import { getMember } from "../../../actions/miscAction";

const useNCNDACheck = () => {
  const [showNCNDA, setShowNCNDA] = useState(false);

  // console.log("location", useLocation());
  const toggleNCNDA = () => {
    setShowNCNDA(!showNCNDA);
  };

  useEffect(() => {
    if (typeof window !== "undefined" && !showNCNDA) {
      const token = localStorage.getItem("token");

      if (token) {
        getPersonalInfo()
          .then((res) => {
            const memberCustomization = localStorage.getItem("customization");
            const dashboardColor = memberCustomization?.dashboard_color;
            const dashboard_secondary_color = memberCustomization?.dashboard_secondary_color;
            const show_custom_dashboard = memberCustomization?.show_custom_dashboard;
            const dashboard_logo = memberCustomization?.dashboard_logo;
            const logo_color = memberCustomization?.is_logo_white;

            if (
              res?.data?.dashboard_color !== dashboardColor ||
              res?.data?.dashboard_secondary_color !== dashboard_secondary_color ||
              res?.data?.show_custom_dashboard != show_custom_dashboard ||
              res?.data?.dashboard_logo != dashboard_logo ||
              res?.data?.is_logo_white != logo_color
            ) {
              localStorage.setItem(
                "customization",
                JSON.stringify({
                  dashboard_color: res?.data?.dashboard_color,
                  dashboard_secondary_color: res?.data?.dashboard_secondary_color,
                  show_custom_dashboard: res?.data?.show_custom_dashboard,
                  dashboard_logo: res?.data?.dashboard_logo,
                  is_logo_white: res?.data?.is_logo_white,
                }),
              );
            }

            const unsignedDoc = res?.data?.ncnda_agreements?.filter((ue) => !ue?.nda_signed_date);
            if (unsignedDoc?.length > 0) {
              toggleNCNDA();
            }
          })
          .catch((err) => {
            console.log("Error", err);
          });
      }
    }
  }, []);

  return { showNCNDA, toggleNCNDA };
};

export default useNCNDACheck;
